<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main.vue'
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'
import PreferredList from '@/components/candidate/guaranteed-list.vue'
export default {
  components: {
    Layout,
    PreferredList,
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
    }),
    compTitle() {
      return 'Guarantees'
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle :title="compTitle" />
    <PreferredList />
  </Layout>
</template>
